import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class BlockStorageRoute extends Route {
  @service availableServices;

  beforeModel() {
    this.availableServices.requireAccessTo(this, "storage");
  }

  model() {
    return { project: this.modelFor("organization").project };
  }
}
